import styled from 'styled-components';
import { Text } from '@awazevr/design-system.components.text';
import { Button } from '@awazevr/design-system.components.button';

export const TextWithMargin = styled(Text)`
  margin-left: 1rem;
  font-size: 1.5rem;

  ${({ theme }) => theme.mediaQueries.phoneDS} {
    font-size: 1.25rem;
  }
`;
export const StyledIconAndHeader = styled.div`
  display: inline-flex;
  margin-bottom: 2rem;
`;

export const StyledButton = styled(Button)`
  ${({ theme }) => theme.mediaQueries.phoneDS} {
    width: 100%;
  }
`;
